import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from '../lib/cx.js';
export function Badge({ tone = 'neutral', dot = false, className, children, ...rest }) {
    return (_jsxs("span", { ...rest, className: cx('clav-badge', `clav-badge--${tone}`, className), children: [dot ? _jsx("span", { className: "clav-badge__dot", "aria-hidden": "true" }) : null, children] }));
}
//# sourceMappingURL=badge.js.map